module.exports = __webpack_public_path__ + "img/dude.8615288f.png";